import { type FC, useState } from 'react';

import UserOutlineIcon from '@/assets/svg/ui-elements/user-outline.svg';
import { getInitials } from '@/utils/get-initials';

import Typography from '../Typography';
import type { TypographyVariant } from '../Typography/types';
import { AvatarImage, StyledAvatar } from './Avatar.styled';
import type { AvatarProps, AvatarSize } from './types';

const TYPOGRAPHY_VARIANT: Record<AvatarSize, TypographyVariant> = {
  sm: 'body3',
  md: 'body2',
  lg: 'body1',
  xl: 'body1',
  '2xl': 'h6',
};

const Avatar: FC<AvatarProps> = ({
  type = 'initials',
  initials = '',
  icon,
  color = 'grey',
  variant = 'subtle',
  size = 'md',
  src,
  alt = '',
  className,
}) => {
  const [failedSrc, setFailedSrc] = useState<string | null>(null);
  const imageSrc = src && src !== failedSrc ? src : null;

  return (
    <StyledAvatar $color={color} $variant={variant} $size={size} className={className}>
      {imageSrc ? (
        <AvatarImage src={imageSrc} alt={alt} onError={() => setFailedSrc(imageSrc)} />
      ) : type === 'icon' ? (
        (icon ?? <UserOutlineIcon />)
      ) : (
        <Typography
          as="span"
          variant={TYPOGRAPHY_VARIANT[size]}
          fontWeight={size === '2xl' ? undefined : 500}
          color="inherit"
          noWrap
        >
          {getInitials(initials)}
        </Typography>
      )}
    </StyledAvatar>
  );
};

Avatar.displayName = 'Avatar';

export default Avatar;
